import { render, staticRenderFns } from "./EditBactParasite.vue?vue&type=template&id=39fc6947"
import script from "./EditBactParasite.vue?vue&type=script&lang=js"
export * from "./EditBactParasite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports